import { http } from './config'

export default {
  cadastrarusuario:(usuario) => {
    return http.post('usuario.php',(usuario));
  },
  alterarusuario:(usuario) => {
    return http.put('usuario.php',(usuario));
  },
  alterarsenha:(usuario) => {
    return http.put('usuario_senha.php',(usuario));
  },
  getByEmail:(email) => {
    return http.get('usuario.php?email='+email)
  },
  getByFone:(fone) => {
    return http.get('usuario.php?fone='+fone)
  },
  getCdUsuario:(telefone) => {
    return http.get(`usuario.php?fone=${telefone}`)
  },
  listandoEmail:(email,telefone) => {
    return http.get('usuario_email.php?email='+email+`&telefone=${telefone}`)
  },
  listandoLogin:(email,senha,fone) => {
    var queryLogin = 'usuario_login.php'
    if(email){
      queryLogin += `?email=${email}`
    }
    if(senha){
      queryLogin += queryLogin.includes("?")?`&senha=${senha}`:`?senha=${senha}`
    }
    if(fone){
      queryLogin += queryLogin.includes("?")?`&fone=${fone}`:`?fone=${fone}`
    }
    return http.get(queryLogin)
  },
  listandotelefone:(email) => {
    return http.get('usuario_telefone.php?email='+email)
  },
  verificarTelefone:(telefone) => {
    return http.get('verifica_telefone.php?fone='+telefone)
  },
  listandoTelefoneLogin:(telefone) => {
    return http.get('usuario_telefone_login.php?fone='+telefone)
  },
}